<template>
  <admin-payment title="Pagina de Pagamento">
    <div class="row">
      <div class="col-lg-2 col-xs-12"></div>
      <div v-if="!plan.id">
        <h1>Plano não encontrado</h1>
      </div>

      <div v-if="plan.id" class="col-lg-8 col-xs-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12 col-lg-12">
                <h4 class="card-title">{{plan.name}}</h4>
                <h6 class="card-subtitle mb-2 text-muted">Assinatura de plano</h6>
                <pre>{{plan.description}}</pre>
                <p>
                  <b>Total de vagas:</b>
                  {{plan.amount_jobs}}
                </p>
                <p>
                  <b>Total de usuários:</b>
                  {{plan.amount_recruiters}}
                </p>

                <p class="f17">
                  <b>Total:</b>
                  <span
                    class="f20"
                  >R$ {{ plan.price ? parseFloat(plan.price).toFixed(2).replace('.', ',') : "0,00" }}</span>
                </p>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-xs-12 col-lg-12">
                <h4 class="mt-4">
                  <b>Dados da conta</b>
                </h4>
              </div>
              <div class="col-lg-6 col-xs-12">
                <label>Nome</label>
                <input type="text" disabled class="form-control" v-model="recruiter.name" />
              </div>
              <div class="col-lg-6 col-xs-12">
                <label>E-mail</label>
                <input type="text" disabled class="form-control" v-model="recruiter.email" />
              </div>
              <div class="col-lg-12 col-xs-12">
                <inputform
                  v-model="account.document_number"
                  type="text"
                  label="CPF ou CNPJ"
                  v-mask="'###############'"
                  :field="$v.account.document_number"
                  class="mt-3"
                />
              </div>
              <div class="col-lg-10 col-xs-12">
                <inputform
                  v-model="account.street"
                  type="text"
                  label="Nome da Rua"
                  :field="$v.account.street"
                  class="mt-1"
                />
              </div>
              <div class="col-lg-2 col-xs-12">
                <inputform
                  v-model="account.number"
                  type="text"
                  label="Número"
                  :field="$v.account.number"
                  class="mt-1"
                />
              </div>
              <div class="col-lg-6 col-xs-12">
                <inputform
                  v-model="account.neighborhood"
                  type="text"
                  label="Bairro"
                  :field="$v.account.neighborhood"
                  class="mt-1"
                />
              </div>
              <div class="col-lg-6 col-xs-12">
                <inputform
                  v-model="account.zipcode"
                  type="text"
                  label="CEP"
                  :field="$v.account.zipcode"
                  class="mt-1"
                />
              </div>
              <div class="col-lg-12 col-xs-12">
                <inputform
                  v-model="account.phone"
                  type="text"
                  label="Telefone"
                  v-mask="'+## (##) #####-####'"
                  :field="$v.account.phone"
                  class="mt-1"
                />
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-lg-12 col-xs-12">
                <h4>
                  <b>Pagamento</b>
                </h4>
              </div>
              <div class="col-lg-12 col-xs-12">
                <label class="mr-3" v-if="plan.payment_methods.includes('credit_card')">
                  <input class="mr-1" v-model="choose" type="radio" value="credit_card" />
                  Cartão de crédito
                </label>
                <label v-if="plan.payment_methods.includes('boleto')">
                  <input v-model="choose" type="radio" class="mr-1" value="boleto" />Boleto
                </label>
              </div>
              <div v-if="choose == 'credit_card'" class="col-lg-12 col-xs-12">
                <div class="row">
                  <div class="col-lg-12 col-xs-12">
                    <inputform
                      v-model="card.card_number"
                      type="text"
                      label="Número do cartão"
                      v-mask="'################'"
                      :field="$v.card.card_number"
                      class="mt-1"
                    />
                  </div>
                  <div class="col-lg-3 col-xs-12">
                    <inputform
                      v-model="card.card_cvv"
                      type="text"
                      label="CVV"
                      :field="$v.card.card_cvv"
                      class="mt-1"
                    />
                  </div>
                  <div class="col-lg-6 col-xs-12">
                    <inputform
                      v-model="card.card_holder_name"
                      type="text"
                      label="Nome impresso no cartão"
                      :field="$v.card.card_holder_name"
                      class="mt-1"
                    />
                  </div>
                  <div class="col-lg-3 col-xs-12">
                    <inputform
                      v-model="card.card_expiration_date"
                      type="text"
                      v-mask="'##/##'"
                      label="Data de expiração"
                      :field="$v.card.card_expiration_date"
                      class="mt-1"
                    />
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-xs-12">
                <button @click="save" class="mt-4 btn btn-degrade full normal-degrade">
                  <span v-show="!load">Assinar Plano</span>
                  <div v-show="load" class="spinner-border text-light" role="status">
                    <span class="sr-only"></span>
                  </div>
                </button>
              </div>
              <div class="col-lg-6 col-xs-12">
                <inertia-link
                  href="/recruiters/dashboard/choose"
                  class="mt-4 btn btn-secondary full"
                >Voltar</inertia-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </admin-payment>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  email,
} from "vuelidate/lib/validators";
export default {
  props: ["account_current", "recruiter", "plan"],
  data: () => ({
    choose: "credit_card",
    load: false,
    card: {
      card_number: "",
      card_cvv: "",
      card_holder_name: "",
      card_expiration_date: "",
    },
    account: {
      document_number: "",
      street: "",
      number: "",
      neighborhood: "",
      zipcode: "",
      phone: "",
    },
  }),
  mounted() {
    this.choose = this.plan.payment_methods[0];
    this.account = this.account_current;

    if (this.account_current.street_number) {
      this.account.number = this.account_current.street_number;
    }

    this.card = {
      card_number: "",
      card_cvv: "",
      card_holder_name: "",
      card_expiration_date: "",
    };
  },
  methods: {
    save() {
      if (this.load == true) {
        return;
      }
      this.load = true;
      this.$v.account.$touch();
      this.$v.card.$touch();
      let error = false;
      if (this.$v.account.$error) {
        this.$toast.error("Preencha os campos da conta corretamente");
        error = true;
      }
      if (this.choose == "credit_card") {
        if (this.$v.card.$error) {
          this.$toast.error("Preencha os campos do pagamento corretamente");
          error = true;
        }
      }

      if (error) {
        return;
        this.load = false;
      }
      axios
        .post("/payments/subscriptions", {
          payment_method: { type: this.choose },
          plans: {
            id: this.plan.id,
            gateway_plan_id: this.plan.gateway_plan_id,
          },
          account: {
            document_number: this.account.document_number,
            street: this.account.street,
            number: this.account.number,
            neighborhood: this.account.neighborhood,
            zipcode: this.account.zipcode,
            phone: this.account.phone,
          },
          card: this.card,
        })
        .then((response) => {
        
          if (!response.data.status) {
            this.$toast.error(response.data.error);
            this.load = false;
            return;
          }
          this.card = {
            card_number: "",
            card_cvv: "",
            card_holder_name: "",
            card_expiration_date: "",
          };
          this.$inertia.visit(
            "/payments/subscriptions/" + this.plan.url + "/success",
            {
              method: "get",
              data: {},
              replace: true,
              preserveState: false,
              preserveScroll: false,
            }
          );
          this.load = false;
        })
        .catch((error) => {
          this.$toast.error("Erro inesperado");
          this.load = false;
        });
    },
  },
  validations: {
    account: {
      document_number: { required, minLength: minLength(11) },
      street: { required, minLength: minLength(4) },
      number: { required },
      street: { required, minLength: minLength(4) },
      neighborhood: { required, minLength: minLength(3) },
      zipcode: { required, minLength: minLength(8) },
      phone: { required, minLength: minLength(18) },
    },
    card: {
      card_number: {
        required,
        minLength: minLength(16),
        maxLength: maxLength(16),
      },
      card_cvv: { required, minLength: minLength(3), maxLength: maxLength(4) },
      card_holder_name: { required, minLength: minLength(4) },
      card_expiration_date: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(5),
      },
    },
  },
};
</script>
